import { useRef } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import Text from '../../../../shared/Text';
import { BaseInput } from '../../../../shared/FormStyles';
import DatePicker from '../../../../shared/DatePicker/DatePicker.jsx';
import { parseDate } from '../../utils/helpers';
import { useClickOutside } from '../../hooks/useClickOutside';
import {
  closeCalendar,
  setShowCalendar,
} from '../../../../lib/redux/campaignCalendar/campaignCalendarSlice';
import defaultAttrs from '../../../../lib/utils/defaultAttrs';

export const DateForm = ({
  handleDateUpdate,
  campaignStartDate,
  campaignEndDate,
  resetForm,
  disabled,
  multiMonth,
}) => {
  const dispatch = useDispatch();
  const dateInputDisplayValue = () =>
    `${parseDate(campaignStartDate, '')} - ${parseDate(campaignEndDate, '')}`;

  const calendarRef = useRef(null);
  const { t } = useTranslation('campaigns');
  const showCalendar = useSelector(
    state => state.campaignCalendar.showCalendar,
  );

  const handleCancel = () => {
    resetForm();
    dispatch(closeCalendar());
  };
  const onCalendarClick = () => {
    if (disabled) return;

    dispatch(setShowCalendar());
  };

  useClickOutside(calendarRef, handleCancel);

  return (
    <Container ref={calendarRef}>
      {!multiMonth && (
        <Text color="black.60" variant="subtitle2">
          {t('dates.noMultiMonth')}
        </Text>
      )}
      <InputWrapper>
        <DateInput
          value={dateInputDisplayValue()}
          readOnly
          placeholder={t('dates.datesPlaceholder')}
          id="campaignDate"
          disabled={disabled}
          title={disabled ? t('dates.disabled') : ''}
          onClick={() => onCalendarClick()}
        />
        <CalendarIcon />
      </InputWrapper>
      {showCalendar && (
        <CalendarWrapper>
          <Text variant="button" fontSize="16px">
            {t('dates.label')}
          </Text>
          <DatePicker
            value={[campaignStartDate, campaignEndDate]}
            minDate="today"
            onChange={dates => handleDateUpdate(dates)}
            size={1.1}
          />
        </CalendarWrapper>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: 5px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 25%;
  margin: auto;
`;

const CalendarWrapper = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 10px;
`;

const DateInput = styled(BaseInput)`
  padding: 12px 16px !important;
  border: 0 !important;
  width: 340px;
  text-overflow: ellipsis;
`;

const InputWrapper = styled.div`
  position: relative;
`;

const CalendarIcon = styled.i.attrs(
  defaultAttrs({
    className: 'fa-light fa-calendar',
  }),
)`
  position: absolute;
  top: 12px;
  right: 10px;
`;
